<template>
	<div class="page">
		<el-form :model="form" :label-position="'right'" label-width="153px" :rules="Rules" ref="infoRef">
			<div class="item_box">
				<el-form-item label="单位名称：" prop="Name">
					<el-input v-model="form.Name" placeholder="请输入" style="width: 23.375rem;"></el-input>
				</el-form-item>

				<el-form-item label="联系人：" prop="Contacts">
					<el-input v-model="form.Contacts" placeholder="请输入" style="width: 23.375rem;"></el-input>
				</el-form-item>

				<el-form-item label="所在城市：" prop="City">
					<el-cascader size="large" :options="options" v-model="form.City" @change="handleChange"
						style="width: 23.375rem;">
					</el-cascader>
				</el-form-item>
			</div>

			<div class="item_box">
				<el-form-item label="详细地址：" prop="Address">
					<el-input v-model="form.Address" placeholder="请输入" style="width: 23.375rem;"></el-input>
				</el-form-item>

				<el-form-item label="手机号：" prop="Mobile">
					<div class="" style="width: 100%;display: flex;">
						<el-input v-model="form.Mobile" placeholder="请输入" style="width: 23.375rem;"
							:disabled="isChange">
						</el-input>
						<el-button type="primary" style="margin-left: 0.625rem;" v-if="isChange"
							@click="isChange = false">变更</el-button>
						<el-button type="primary" style="margin-left: 0.625rem;" v-if="!isChange" @click="getCode">
							{{isCode ? ''+time+'秒后可重试' :'获取验证码'}}
						</el-button>
					</div>

				</el-form-item>

				<el-form-item label="验证码：" prop="code" v-if="!isChange">
					<el-input v-model="form.code" placeholder="请输入" style="width: 23.375rem;"></el-input>
				</el-form-item>

				<el-form-item label="店铺简称：" prop="StoreName">
					<el-input v-model="form.StoreName" placeholder="请输入" style="width: 23.375rem;"></el-input>
				</el-form-item>
			</div>

			<div class="" style="margin-top: 1.25rem;">
				<el-form-item label="客服微信二维码：" prop="WeChatPic">
					<el-upload class="avatar-uploader" action="https://aavisa.com/" :show-file-list="false"
						:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-exceed="handleExceed">
						<img v-if="form.WeChatPic" :src="form.WeChatPic" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>

				<el-button type="primary" @click="submit">提交</el-button>
			</div>
		</el-form>

	</div>
</template>

<script>
	import {
		regionData,
		TextToCode,
		codeToText,
		pcTextArr,
		pcaTextArr
	} from "element-china-area-data"; //导入省市区
	export default {
		name: "accountinfo",
		data: function() {
			return {
				options: pcaTextArr,
				selectedOptions: [],
				addForm: {},
				imageUrl: '',
				isCode: false,
				isChange: true,
				time: 60,
				Rules: {
					Mobile: [{
						validator: this.checkPhone,
						trigger: 'blur'
					}, {
						required: true,
						message: '手机号不能为空',
						trigger: 'blur'
					}],
					Name: [{
						required: true,
						message: '单位名称不能为空',
						trigger: 'blur'
					}],
					StoreName: [{
						required: true,
						message: '店铺简称不能为空',
						trigger: 'blur'
					}],
					Contacts: [{
						required: true,
						message: '联系人不能为空',
						trigger: 'blur'
					}],
					City: [{
						required: true,
						message: '城市不能为空',
						trigger: 'blur'
					}],
					Address: [{
						required: true,
						message: '详细地址不能为空',
						trigger: 'blur'
					}],
					code: [{
						required: true,
						message: '验证码不能为空',
						trigger: 'blur'
					}],
				},
				form: {
					Name: '', // 单位名称
					StoreName: '', // 店铺简称
					Contacts: '', // 联系人
					City: '', // 城市
					Address: '', // 详细地址
					IsSubStore: '', // 
					Mobile: '', // 手机号
					WeChatPic: '', // 微信二维码
					code: '',
				},

			}
		},
		created: function() {
			this.GetStoreInfo()
		},
		methods: {
			checkPhone(rule, value, callback) {
				const emailRegex = /^1[3456789]\d{9}$/;
				emailRegex.test(value) ? callback() : callback(new Error("手机格式错误"))
			},

			getCode() {
				let {
					isChange
				} = this;
				let {
					Mobile
				} = this.form;

				// Mobile = Mobile.replace(' ', '');

				if (this.isCode) return false;

				this.$api.RegisterSendMsg({
					phone: Mobile
				}).then(res => {
					let {
						message
					} = res.data
					this.$message(message)
				})

				this.isCode = true
				let time = this.time
				var st = setInterval(() => {
					this.time = this.time - 1
					if (this.time <= 0) {
						clearInterval(st)
						this.isCode = false;
						this.time = time
					}
				}, 1000)

			},

			handleAvatarSuccess(res, file) {
				console.log(res, file)
				this.form.WeChatPic = URL.createObjectURL(file.raw);
			},
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isLt2M;
			},

			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},

			GetStoreInfo() {
				let storeId = cookie.get('storeId')
				this.$api.GetStoreInfo({
					storeId
				}).then(res => {
					console.log(res.data, 'GetStoreInfo')
					let {
						status,
						data
					} = res.data;
					if (status == 200) {
						data.City = JSON.parse(data.City)
						
						this.form = data;
					}
				}).catch(err => {
					console.log(err, 'GetStoreInfo')
				})
			},

			submit() {
				this.$refs.infoRef.validate(is => {
					if (is) {
						let parment = this.form;
						parment.City = JSON.stringify(this.form.City);
						parment.Storeid = cookie.get('storeId')
						this.$api.SaveStoreInfo(parment).then(res => {
							console.log(res);
							let {
								data,
								status
							} = res.data;
							if (status == 200) {
								this.$message.success('修改成功')
							}else{
								this.$message.error('修改失败')
							}
							this.GetStoreInfo()
						}).catch(err => {
							this.GetStoreInfo()
							this.$message.error('修改失败')
						})
					}
				})

			},


			// 在获取详情信息接口中使用 codeToText 将字符串转换成编码赋给 selectedOptions 
			projectInfo() {
				var that = this;
				getProjectInfo({
					token: getToken(),
					id: that.id
				}).then(res => {
					this.addForm = {
						id: res.id,
						// 基础信息
						p_name: res.p_name, //项目名
						p_message: res.p_message, //项目信息
						area: res.area, //地区
						remark: res.remark, //备注
					}
					this.selectedOptions = codeToText[this.addForm.area.split('/')[0]][this.addForm.area.split(
						'/')[1]][this.addForm.area.split('/')[2]].code;

				}).catch(err => {
					Message.error(err)
				})
			},
			handleChange(value) {
				this.getCodeToText(null, value)
			},
			getCodeToText(codeStr, codeArray) {
				console.log(codeArray)

				if (null === codeStr && null === codeArray) {
					return null;
				} else if (null === codeArray) {
					codeArray = codeStr.split(",");
				}
				let area = [];
				switch (codeArray.length) {
					case 1:
						area.push(codeToText[codeArray[0]]);
						break;
					case 2:
						area.push(codeToText[codeArray[0]], codeToText[codeArray[1]]);
						break;
					case 3:
						area.push(codeToText[codeArray[0]], codeToText[codeArray[1]], codeToText[codeArray[2]]);
						break;
					default:
						break;
				}
				console.log(area)
				this.addForm.area = area
				return area;
			}

		}

	}
</script>

<style lang="less" scoped>
	div {
		text-align: left;
	}

	.page {
		overflow: hidden;

		.el-button {
			margin-left: 10.25rem;
			padding: 0.625rem 2.875rem;
		}

		.item_box {
			padding: 1.25rem 0 0rem;
			border-bottom: 1px solid #eee;

		}
	}

	/deep/ .avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	/deep/.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	/deep/.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>



// WEBPACK FOOTER //
// src/page/personcenter/accountinfo.vue